// Petra Fina: global WhatsApp contact button.
(function () {
  if (window.__petraWhatsappButton) return;
  window.__petraWhatsappButton = true;

  function inject() {
    if (!document.body || document.querySelector('.petra-whatsapp-button')) return;

    var style = document.createElement('style');
    style.id = 'petra-whatsapp-button-style';
    style.textContent = [
      '.petra-whatsapp-button { position: fixed; right: max(18px, env(safe-area-inset-right)); bottom: max(20px, env(safe-area-inset-bottom)); z-index: 9998; display: inline-flex; align-items: center; justify-content: center; width: 54px; height: 54px; padding: 0; border: 0; border-radius: 50%; background: #25d366; color: #fff !important; text-decoration: none !important; box-shadow: 0 5px 16px rgba(0, 0, 0, .22); }',
      '.petra-whatsapp-button:hover, .petra-whatsapp-button:focus-visible { background: #187b43; color: #fff !important; outline: 2px solid #fff; outline-offset: 2px; }',
      '.petra-whatsapp-button img { display: block; width: 28px; height: 28px; }',
      '@media (max-width: 767px) { .petra-whatsapp-button { right: 14px; bottom: max(16px, env(safe-area-inset-bottom)); width: 50px; height: 50px; } .petra-whatsapp-button img { width: 26px; height: 26px; } }'
    ].join('\n');
    document.head.appendChild(style);

    var button = document.createElement('a');
    button.className = 'petra-whatsapp-button';
    button.href = 'https://wa.me/5511971698885';
    button.target = '_blank';
    button.rel = 'noopener';
    button.setAttribute('aria-label', 'Falar com a Petra Fina pelo WhatsApp');
    var icon = document.createElement('img');
    icon.alt = '';
    icon.setAttribute('aria-hidden', 'true');
    icon.src = new URL('petra-whatsapp-icon.svg', document.currentScript.src).href;
    button.appendChild(icon);
    document.body.appendChild(button);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inject);
  else inject();
})();
